<template>
	<div>
		<header class="page-title">
			<div class="flex box start six">
				<div class="form-group four">
					<input name="dateFrom" type="date" v-model="dateFrom">
				</div>
				<div class="form-group four">
					<input name="dateTo" type="date" v-model="dateTo">
				</div>
				<div class="form-group four-lg mb-0">
					<button class="btn btn-md btn-success" @click="loadData()">Show data</button>
				</div>
			</div>
			<div class="ml-auto">
				Sales: <strong>{{ basicData.sales }}</strong>  Revenue: <strong>${{ basicData.commissions }}</strong>
			</div>
		</header>

		<div class="flex box" v-if="userRoles.includes('dashboard_access.view')">
			<div class="seven-lg">
				<div class="card">
					<header class="card-header">
						<h3 class="card-title">Charts</h3>
					</header>

					<div class="card-body">
						The data should show up here
					</div>
				</div>

				<div class="card">
					<header class="card-header">
						<h3 class="card-title">Page Stats</h3>
					</header>

					<div class="card-body">
						<div v-if="pageStats" class="table-lister table-responsive">
							<table>
								<thead>
								<tr>
									<th><span class="th">#</span></th>
									<th><span class="th">Display date</span></th>
									<th>Article tag data</th>
									<th>Sales</th>
								</tr>
								</thead>
								<tbody>
								<tr v-for="(pageStat, index) in pageStats">
									<td>{{ index+1 }}</td>
									<td>{{ pageStat.display_date }}</td>
									<td>
										<strong class="article-title">{{ pageStat.tag }}</strong>
										<div class="article-links">
											{{ pageStat.url }}
										</div>
									<td>
										<strong class="article-title">{{ pageStat.count }}</strong>
										<div class="article-links">
											<span class="badge badge-default">${{ pageStat.sum }}</span>
										</div>
									</td>
								</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>

			<div class="five-lg">
				<div class="card">
					<header class="card-header">
						<h3 class="card-title">Providers and tags</h3>
					</header>

					<div class="card-body">
						<div class="flex box">
							<div class="six-lg">
								<div v-if="providers" class="table-lister table-responsive">
									<table>
										<thead>
										<tr>
											<th>Providers</th>
										</tr>
										</thead>
										<tbody>
										<tr v-for="provider in providers">
											<td><input type="checkbox" @click="filterByProvider(provider.id)"> {{ provider.name }}</td>
										</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="six-lg">
								<div v-if="tags" class="table-lister table-responsive">
									<table>
										<thead>
										<tr>
											<th>Tags</th>
										</tr>
										</thead>
										<tr>
											<td>
												<input v-model="searchTags" id="search" class="input-small" name="search" type="text" placeholder="Search in Tags">
											</td>
										</tr>
										<tbody>
										<tr v-for="tag in search">
											<td><input type="checkbox" @click="filterByTag(tag)"> {{ tag }}</td>
										</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
import {eventBus} from "../../app";

export default {
	name: "CommissionSmallReport",
	props: {
		dataBasicData: {
			type: Object
		},
		dataPageStats: {
			type: Array,
			required: false
		},
		dataProviders: {
			type: Array,
			required: false
		},
		dataAllTags: {
			type: Object,
			required: false
		}
	},
	data() {
		return {
			basicData: this.dataBasicData,
			pageStats: this.dataPageStats,
			providers: this.dataProviders,
			tags: this.dataAllTags,
			searchTags: '',

			userRoles: this.$currentUserRoles,
			selectedProviders: [],
			selectedTags: [],
			dateFrom: this.dataBasicData.dateFrom,
			dateTo: this.dataBasicData.dateTo
		}
	},
	computed: {
		search() {
			const allTags = Object.values(this.tags);
			return allTags.filter(tag => String(tag).includes(this.searchTags));
		}
	},
	methods: {
		filterByProvider: function (provider) {
			let vm = this;

			if (vm.selectedProviders.includes(provider)) {
				vm.selectedProviders = vm.selectedProviders.filter(function(item) {
					return item !== provider
				})
			} else {
				vm.selectedProviders.push(provider);
			} // if

			this.loadData();
		},
		filterByTag: function (tag) {
			let vm = this;

			if (vm.selectedTags.includes(tag)) {
				vm.selectedTags = this.selectedTags.filter(function(item) {
					return item !== tag
				})
			} else {
				vm.selectedTags.push(tag);
			} // if

			this.loadData();
		},
		loadData: function () {
			let vm = this;
			let data = {
				'providers': this.selectedProviders,
				'tags': this.selectedTags,
				'dateFrom': this.dateFrom,
				'dateTo': this.dateTo,
			}

			eventBus.$emit('onLoaderStart');
			axios.post('/api/' + this.$selectedSite.slug + '/commissionSmallReport/getReportData', data)
				.then(function (response) {
					if (response.data) {
						vm.pageStats = response.data.pageStats;
						vm.basicData.sales = response.data.overallCount;
						vm.basicData.commissions = response.data.overallSum;
						eventBus.$emit('onLoaderFinish');
						vm.$toastr.success('Data loaded', 'Success');
					} // if
				})
				.catch(function (e) {
					eventBus.$emit('onLoaderFinish');
					vm.$toastr.error('Could not load the data.', 'Error');
				});
		}
	}
}
</script>

<style scoped>

</style>
